import { Component } from '@angular/core';
import {MenuController, Platform} from '@ionic/angular';
import {LocaldbService} from './services/localdb.service';
import {StorageService} from './services/storage.service';
import {TranslateService} from '@ngx-translate/core';
import {ApiService} from "./services/api.service";
import {Router} from "@angular/router";
import {GetDataService} from "./services/getdata.service";
import {SplashScreen} from "@capacitor/splash-screen";
import {environment} from "../environments/environment.prod";

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  public value = [];
  public menuItems = [];
  public lang = '';
  public version = null;

  constructor(
    private platform: Platform,
    private dbService: LocaldbService,
    private storageService: StorageService,
    private translateService: TranslateService,
    private apiService: ApiService,
    private menuController: MenuController,
    private router: Router,
    private getDataService: GetDataService
  ) {
    this.initializeApp().then();
  }

  async initializeApp() {

    await SplashScreen.hide();

    this.platform.ready().then(async () => {

      this.version = environment.version;

      let lng = await this.storageService.language();
      if (lng === null) {
        lng = 'en'
      } else {
        this.translateService.use(lng);
      }

      if (lng === 'en' || lng === 'de') {
        this.lang = this.translateService.instant('LANGUAGE.' + lng.toUpperCase());
      } else {
        lng = 'en';
        this.translateService.use(lng);
        this.lang = this.translateService.instant('LANGUAGE.' + lng.toUpperCase());
      }

      await this.dbService.init();

      // try to copy the data from live db to local db (asynchronously)
      await this.apiService.getLiveTables('icd').then();
      await this.apiService.getLiveTables('atc').then();
      await this.apiService.getLiveTables('config').then();

      await this.getDataService.doGetMenu().then((result) => {
        for (const key in result) {
          if (result[key]) {
            this.value.push(result[key]);
          }
        }
        this.menuItems = [
          { showItem: this.value[1] , title: 'INDICATIONSEARCH', url: '/indication-search', icon: 'search-outline', color: 'primary'},
          { showItem: this.value[2] , title: 'SUBSTANCESEARCH', url: '/substance-search', icon: 'search-outline', color: 'primary'},
          { showItem: this.value[3] , title: 'ATCCODESEARCH', url: '/atc-search', icon: 'search-outline', color: 'primary'},
          { showItem: this.value[4] , title: 'ICDCODESEARCH', url: '/icd-search', icon: 'search-outline', color: 'primary'},
          { showItem: this.value[5] , title: 'ABOUT_US', url: '/about', icon: 'people-outline', color: 'primary'},
          { showItem: this.value[6] , title: 'DISCLAIMER', url: '/disclaimer/menu', icon: 'newspaper-outline', color: 'primary'},
          { showItem: this.value[7] , title: 'APP_NOTES', url: '/apphints', icon: 'information-outline', color: 'primary'},
          { showItem: this.value[8] , title: 'CREDENTIALS', url: '/references', icon: 'list-outline', color: 'primary'},
          { showItem: this.value[9] , title: 'DATAPRIVACY', url: '/data-privacy', icon: 'shield-checkmark-outline', color: 'primary'},
        ];
      }).catch((e) => {});
    }).catch((e) => {
        console.log('mylog platform not ready')
    });
  }

  go(url) {
    this.menuController.close().then();
    this.router.navigate([url]).then();
  }

  async translate(event) {
    const lng = event.detail.value;
    await this.translateService.use(lng);
    await this.storageService.language(lng);
    window.location.reload();
  }
}
